import React from "react";
import "./index.scss"; // スタイルシートのインポート

const PcStepProgressBar = ({ currentStep }) => {
  const totalSteps = 7; // ステップの総数 (step0 から step6 まで)

  return (
    <div className="PcStepProgressBar">
      <div className="stepper-wrapper">
        {Array.from({ length: totalSteps }, (_, index) => {
          // index は 0 から 6 までの値を取ります
          let stepClass = "step-item";

          if (index < currentStep - 1) {
            stepClass += " done";
          } else if (index === currentStep - 1) {
            stepClass += " wip";
          }
          // index > currentStep の場合は、基本クラス 'step-item' のみ

          return (
            <div
              id={`step${index}`}
              className={stepClass}
              key={`step${index}`} // Reactのリストレンダリングにはkeyが必要
            >
              <div className="step-counter"></div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PcStepProgressBar;
